/**
 * Takes n elements from the beginning of an array
 */
export const take = <T>(array: T[], n: number): T[] => {
  return array.slice(0, Math.max(0, n))
}
